
import { useState, useMemo, useEffect } from "react";

const paineis = [
  { id: "REC #01", nome: "Agamenon Centro de Convenções", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 27, nits: 6500 },
  { id: "REC #02", nome: "17 de Agosto Casa Forte", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 27, nits: 6500 },
  { id: "REC #03", nome: "Ernesto de Paula Santos", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 15, nits: 6500 },
  { id: "REC #04", nome: "Agamenon Derby", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 27, nits: 6500 },
  { id: "REC #05", nome: "Agamenon Ilha do Leite", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "A definir", area: 27, nits: 6500 },
  { id: "REC #06", nome: "Mascarenhas de Morais", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "A definir", area: 15, nits: 6500 },
  { id: "REC #07", nome: "Rosa e Silva", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 27, nits: 6500 },
  { id: "REC #08", nome: "Capunga", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 15, nits: 6500 },
  { id: "REC #09", nome: "Abdias de Carvalho", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 27, nits: 6500 },
  { id: "REC #10", nome: "José Bonifácio Madalena", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 15, nits: 6500 },
  { id: "REC #11", nome: "Via Mangue", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "A definir", area: 27, nits: 6500 },
  { id: "REC #12", nome: "17 de Agosto Parnamirim", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 15, nits: 6500 },
  { id: "REC #15", nome: "José Bonifácio Torre", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 27, nits: 6500 },
  { id: "REC #16", nome: "Rosa e Silva Graças", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 27, nits: 6500 },
  { id: "REC #17", nome: "Rui Barbosa Graças", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 15, nits: 6500 },
  { id: "REC #18", nome: "Domingos Ferreira - Shopping Recife", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "A definir", area: 27, nits: 6500 },
  { id: "REC #19", nome: "Antônio de Goes Praia do Pina", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "A definir", area: 27, nits: 6500 },
  { id: "REC #20", nome: "Mascarenhas de Morais FPS", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "A definir", area: 27, nits: 6500 },
  { id: "REC #21", nome: "Av. Norte Encruzilhada", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 15, nits: 6500 },
  { id: "REC #22", nome: "Ribeiro de Brito - Shopping Recife", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "A definir", area: 15, nits: 6500 },
  { id: "REC #23", nome: "Real da Torre - Mercado da Madalena", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 8, nits: 6500 },
  { id: "REC #24", nome: "Estrada do Encanamento - Clube Alemão", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 15, nits: 6500 },
  { id: "REC #25", nome: "Av. João de Barros / Agamenon", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 15, nits: 6500 },
  { id: "REC #26", nome: "Cônego Barata - Parque Tamarineira", cidade: "Recife/PE", sistema: "Circuito Recife", orientacao: "Norte", area: 15, nits: 6500 },
  { id: "CAM#101", nome: "Praça Camaragibe/Acesso Camaragibe", cidade: "Camarigibe/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "CAM#102", nome: "Praça Camaragibe/Acesso Recife", cidade: "Camarigibe/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "CAM#103DF", nome: "Praça da Gruta/Camará Shopping", cidade: "Camarigibe/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "CG #0103", nome: "Otácilio Nepomuceno - Design Mall", cidade: "Campina Grande/PB", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "CG #101", nome: "Dr. Severino Cruz", cidade: "Campina Grande/PB", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "CG #102", nome: "Pref. Severino Bezerra Cabral", cidade: "Campina Grande/PB", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "CG #104DF", nome: "Severino Cruz - Bar do Cuscuz", cidade: "Campina Grande/PB", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "OLI#101DF", nome: "Praça do Carmo/Cidade Alta", cidade: "Olinda/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "OLI#102", nome: "Praça do Fortim", cidade: "Olinda/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "OLI#103DF", nome: "Orla Bairro Novo", cidade: "Olinda/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "OLI#104DF", nome: "Acesso Shopping Patteo", cidade: "Olinda/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "OLI#105DF", nome: "Praia do Quartel", cidade: "Olinda/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "OLI#106DF", nome: "Shopping Patteo/Praia do Quartel", cidade: "Olinda/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "OLI#107DF", nome: "Mix Mateus/Shopping Patteo", cidade: "Olinda/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "OLI#108DF", nome: "Atacadão/Flat Quatro Rodas", cidade: "Olinda/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "OLI#109DF", nome: "Praça Pedro Jorge", cidade: "Olinda/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
  { id: "OLI#110", nome: "Varadouro/Convento", cidade: "Olinda/PE", sistema: "Relógios", orientacao: "A definir", area: 2, nits: 5000 },
];

// Percentuais calibrados pelo ângulo solar de junho (8°S).
const CURVAS_PADRAO = {
  Norte: [
    { faixa: "23h–05h", pct: 5, label: "Madrugada" },
    { faixa: "05h–12h", pct: 70, label: "Manhã" },
    { faixa: "12h–17h", pct: 100, label: "Tarde (pico)" },
    { faixa: "17h–17:45h", pct: 50, label: "Transição" },
    { faixa: "17:45h–23h", pct: 15, label: "Noite" },
  ],
  Leste: [
    { faixa: "23h–05h", pct: 5, label: "Madrugada" },
    { faixa: "05h–12h", pct: 100, label: "Manhã (pico ☀️)" },
    { faixa: "12h–17h", pct: 45, label: "Tarde" },
    { faixa: "17h–17:45h", pct: 45, label: "Transição" },
    { faixa: "17:45h–23h", pct: 15, label: "Noite" },
  ],
  Oeste: [
    { faixa: "23h–05h", pct: 5, label: "Madrugada" },
    { faixa: "05h–12h", pct: 45, label: "Manhã" },
    { faixa: "12h–17h", pct: 100, label: "Tarde (pico ☀️)" },
    { faixa: "17h–17:45h", pct: 50, label: "Transição" },
    { faixa: "17:45h–23h", pct: 20, label: "Noite" },
  ],
  Sul: [
    { faixa: "23h–05h", pct: 5, label: "Madrugada" },
    { faixa: "05h–12h", pct: 65, label: "Manhã" },
    { faixa: "12h–17h", pct: 65, label: "Tarde" },
    { faixa: "17h–17:45h", pct: 45, label: "Transição" },
    { faixa: "17:45h–23h", pct: 15, label: "Noite" },
  ],
};

const ORIENTACOES = ["Norte", "Sul", "Leste", "Oeste", "A definir"];
const CIDADES = ["Todas", "Recife/PE", "Olinda/PE", "Camarigibe/PE", "Campina Grande/PB"];
const FAIXAS = CURVAS_PADRAO.Norte.map(c => c.faixa);

const STORAGE_KEY = "trend-brilho-paineis-v1";
const CURVAS_KEY = "trend-brilho-curvas-v1";
const API_URL = "https://zapdados.app.n8n.cloud/webhook/brilho-paineis";
const CURVAS_API_URL = "https://zapdados.app.n8n.cloud/webhook/brilho-curvas";

function carregarCurvas() {
  try {
    const salvo = JSON.parse(localStorage.getItem(CURVAS_KEY));
    if (!salvo) return CURVAS_PADRAO;
    // Mescla por orientação/index (faixa é editável) para tolerar mudanças no padrão
    const merge = {};
    for (const orient of Object.keys(CURVAS_PADRAO)) {
      merge[orient] = CURVAS_PADRAO[orient].map((slot, i) => {
        const s = salvo[orient]?.[i];
        return s ? { ...slot, faixa: s.faixa ?? slot.faixa, pct: s.pct ?? slot.pct } : slot;
      });
    }
    return merge;
  } catch {
    return CURVAS_PADRAO;
  }
}

function carregarEstado() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function salvarEstado(lista) {
  try {
    const estado = {};
    lista.forEach(p => {
      estado[p.id] = { status: p.status, orientacao: p.orientacao, obs: p.obs };
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(estado));
  } catch {}
}

function syncPainel(p) {
  fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      painel_id: p.id,
      status: p.status,
      orientacao: p.orientacao,
      obs: p.obs || "",
    }),
  }).catch(() => {});
}

function syncCurva(orientacao, index, faixa, pct) {
  fetch(CURVAS_API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: `${orientacao}_${index}`, orientacao, faixa, pct }),
  }).catch(() => {});
}

function pctColor(p) {
  if (p >= 80) return "#f97316";
  if (p >= 50) return "#facc15";
  if (p >= 20) return "#38bdf8";
  return "#64748b";
}

function buildTheme(light) {
  if (light) {
    return {
      bg: "#f1f5f9",
      panel: "#ffffff",
      panelAlt: "#f8fafc",
      border: "#e2e8f0",
      borderRow: "#f1f5f9",
      text: "#1e293b",
      textBright: "#0f172a",
      textMuted: "#475569",
      textSubtle: "#64748b",
      barBg: "#e2e8f0",
      pillBg: "#dbeafe",
      pillText: "#1e40af",
      inputBg: "#ffffff",
      inputBorder: "#cbd5e1",
      selectBg: "#f8fafc",
      selectBorder: "#cbd5e1",
      alertRowBg: "#fef2f2",
      statusBg: { "Pendente": "#fee2e2", "Em andamento": "#fef3c7", "Concluído": "#dcfce7" },
      statusFg: { "Pendente": "#b91c1c", "Em andamento": "#a16207", "Concluído": "#15803d" },
      headerBg: "linear-gradient(135deg, #1e1b4b 0%, #3730a3 100%)",
      headerText: "#f1f5f9",
      headerSubtle: "#cbd5e1",
      tabBgActive: "transparent",
      cardInner: "#f8fafc",
    };
  }
  return {
    bg: "#070c16",
    panel: "#0f172a",
    panelAlt: "#070c16",
    border: "#1e293b",
    borderRow: "#0f172a",
    text: "#cbd5e1",
    textBright: "#f1f5f9",
    textMuted: "#94a3b8",
    textSubtle: "#94a3b8",
    barBg: "#1e293b",
    pillBg: "#1e3a5f",
    pillText: "#38bdf8",
    inputBg: "#0f172a",
    inputBorder: "#1e293b",
    selectBg: "#1e293b",
    selectBorder: "#334155",
    alertRowBg: "#1a0f0f",
    statusBg: { "Pendente": "#450a0a", "Em andamento": "#451a03", "Concluído": "#052e16" },
    statusFg: { "Pendente": "#ef4444", "Em andamento": "#f59e0b", "Concluído": "#22c55e" },
    headerBg: "linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)",
    headerText: "#f1f5f9",
    headerSubtle: "#cbd5e1",
    tabBgActive: "transparent",
    cardInner: "#070c16",
  };
}

function BrilhoBar({ pct, theme }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div style={{ flex: 1, background: theme.barBg, borderRadius: 4, height: 6, overflow: "hidden" }}>
        <div style={{ width: `${pct}%`, height: "100%", background: pctColor(pct), borderRadius: 4, transition: "width 0.4s" }} />
      </div>
      <span style={{ color: pctColor(pct), fontWeight: 700, minWidth: 36, fontSize: 12 }}>{pct}%</span>
    </div>
  );
}

export default function App() {
  const [light, setLight] = useState(false);
  const theme = useMemo(() => buildTheme(light), [light]);

  const [aba, setAba] = useState("paineis");
  const [filtroOrient, setFiltroOrient] = useState("Todas");
  const [filtroCidade, setFiltroCidade] = useState("Todas");
  const [filtroStatus, setFiltroStatus] = useState("Todos");
  const [busca, setBusca] = useState("");
  const [paineisList, setPaineisList] = useState(() => {
    const salvo = carregarEstado();
    return paineis.map(p => ({
      ...p,
      status: salvo[p.id]?.status ?? "Pendente",
      obs: salvo[p.id]?.obs ?? "",
      orientacao: salvo[p.id]?.orientacao ?? p.orientacao,
    }));
  });
  const [curvaOrient, setCurvaOrient] = useState("Norte");
  const [curvas, setCurvas] = useState(carregarCurvas);

  const [editingOrient, setEditingOrient] = useState({});
  const [novaOrient, setNovaOrient] = useState({});
  const [pagPaineis, setPagPaineis] = useState(1);

  // Operacional tab filters
  const [opPainel, setOpPainel] = useState("Todos");
  const [opFaixa, setOpFaixa] = useState("Todas");
  const [opOrient, setOpOrient] = useState("Todas");
  const [opPagina, setOpPagina] = useState(1);
  const OP_POR_PAGINA = 20;
  const POR_PAGINA = 20;

  const paineisFiltrados = paineisList.filter(p => {
    const matchOrient = filtroOrient === "Todas" || p.orientacao === filtroOrient;
    const matchCidade = filtroCidade === "Todas" || p.cidade === filtroCidade;
    const matchStatus = filtroStatus === "Todos" || p.status === filtroStatus;
    const matchBusca = p.nome.toLowerCase().includes(busca.toLowerCase()) || p.id.toLowerCase().includes(busca.toLowerCase());
    return matchOrient && matchCidade && matchStatus && matchBusca;
  });

  const total = paineisList.length;
  const configurados = paineisList.filter(p => p.orientacao !== "A definir").length;
  const concluidos = paineisList.filter(p => p.status === "Concluído").length;
  const naoDefinidos = total - configurados;

  const operacional = useMemo(() => {
    const rows = [];
    paineisList.forEach(p => {
      if (p.orientacao === "A definir") {
        rows.push({ id: p.id, nome: p.nome, orient: "A definir", faixa: "—", pct: null, label: "Sem curva", placeholder: true });
        return;
      }
      const curva = curvas[p.orientacao];
      if (!curva) return;
      curva.forEach(slot => {
        rows.push({ id: p.id, nome: p.nome, orient: p.orientacao, faixa: slot.faixa, pct: slot.pct, label: slot.label, placeholder: false });
      });
    });
    return rows;
  }, [paineisList, curvas]);

  const operacionalFiltrado = useMemo(() => operacional.filter(r => {
    const mP = opPainel === "Todos" || r.id === opPainel;
    const mF = opFaixa === "Todas" || r.faixa === opFaixa || (r.placeholder && opFaixa === "Todas");
    const mO = opOrient === "Todas" || r.orient === opOrient;
    return mP && mF && mO;
  }), [operacional, opPainel, opFaixa, opOrient]);

  const opTotalPaginas = Math.max(1, Math.ceil(operacionalFiltrado.length / OP_POR_PAGINA));
  const opPaginaAtual = Math.min(opPagina, opTotalPaginas);
  const opPaginado = operacionalFiltrado.slice((opPaginaAtual - 1) * OP_POR_PAGINA, opPaginaAtual * OP_POR_PAGINA);

  useEffect(() => { setOpPagina(1); }, [opPainel, opFaixa, opOrient, paineisList]);
  useEffect(() => { setPagPaineis(1); }, [filtroOrient, filtroCidade, filtroStatus, busca]);
  useEffect(() => { salvarEstado(paineisList); }, [paineisList]);

  useEffect(() => {
    fetch(API_URL)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(remoto => {
        setPaineisList(prev => prev.map(p => ({
          ...p,
          status: remoto[p.id]?.status ?? p.status,
          orientacao: remoto[p.id]?.orientacao ?? p.orientacao,
          obs: remoto[p.id]?.obs ?? p.obs,
        })));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    fetch(CURVAS_API_URL)
      .then(r => r.ok ? r.json() : Promise.reject())
      .then(remoto => {
        // Servidor é a fonte de verdade ao carregar. Mescla por index (i) para
        // preservar a posição/ordem e tolerar slots ausentes (default permanece).
        setCurvas(prev => {
          const merge = {};
          for (const orient of Object.keys(prev)) merge[orient] = prev[orient].map(s => ({ ...s }));
          for (const orient of Object.keys(remoto)) {
            if (!merge[orient]) continue;
            for (const e of remoto[orient]) {
              const i = typeof e.i === "number" ? e.i : null;
              if (i != null && merge[orient][i]) {
                merge[orient][i] = { ...merge[orient][i], faixa: e.faixa, pct: e.pct };
              }
            }
          }
          return merge;
        });
      })
      .catch(() => {});
  }, []);

  const totalPaginasPaineis = Math.max(1, Math.ceil(paineisFiltrados.length / POR_PAGINA));
  const paginaPaineisAtual = Math.min(pagPaineis, totalPaginasPaineis);
  const paineisPaginados = paineisFiltrados.slice((paginaPaineisAtual - 1) * POR_PAGINA, paginaPaineisAtual * POR_PAGINA);

  function iniciarEdicao(id, atual) {
    setEditingOrient(prev => ({ ...prev, [id]: true }));
    setNovaOrient(prev => ({ ...prev, [id]: atual === "A definir" ? "" : atual }));
  }

  function cancelarEdicao(id) {
    setEditingOrient(prev => { const n = { ...prev }; delete n[id]; return n; });
    setNovaOrient(prev => { const n = { ...prev }; delete n[id]; return n; });
  }

  function salvarOrientacao(id) {
    const orient = novaOrient[id];
    if (!orient) return;
    const novaLista = paineisList.map(p => {
      if (p.id !== id) return p;
      const novoStatus = orient !== "A definir" && p.status === "Pendente" ? "Em andamento" : p.status;
      return { ...p, orientacao: orient, status: novoStatus };
    });
    setPaineisList(novaLista);
    const alvo = novaLista.find(p => p.id === id);
    if (alvo) syncPainel(alvo);
    cancelarEdicao(id);
  }

  function toggleStatus(id) {
    const ciclo = ["Pendente", "Em andamento", "Concluído"];
    const novaLista = paineisList.map(p => {
      if (p.id !== id) return p;
      const idx = ciclo.indexOf(p.status);
      return { ...p, status: ciclo[(idx + 1) % ciclo.length] };
    });
    setPaineisList(novaLista);
    const alvo = novaLista.find(p => p.id === id);
    if (alvo) syncPainel(alvo);
  }

  function exportarOperacionalCSV() {
    const meta = {};
    paineisList.forEach(p => { meta[p.id] = { cidade: p.cidade, sistema: p.sistema }; });
    const header = ["Painel ID", "Nome", "Cidade", "Sistema", "Orientação", "Faixa horária", "% Brilho", "Período"];
    const esc = v => {
      const s = String(v ?? "");
      return /[",\n;]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
    };
    const linhas = operacionalFiltrado.map(r => [
      r.id, r.nome, meta[r.id]?.cidade ?? "", meta[r.id]?.sistema ?? "",
      r.orient, r.placeholder ? "—" : r.faixa, r.pct == null ? "" : r.pct + "%", r.label,
    ]);
    const csv = "﻿" + [header, ...linhas].map(l => l.map(esc).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "plano_operacional.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  function ajustarPct(orient, index, valor) {
    const n = Math.max(0, Math.min(100, Math.round(Number(valor) || 0)));
    setCurvas(prev => ({
      ...prev,
      [orient]: prev[orient].map((slot, i) => i === index ? { ...slot, pct: n } : slot),
    }));
    syncCurva(orient, index, curvas[orient][index].faixa, n);
  }

  function ajustarFaixa(orient, index, novaFaixa) {
    setCurvas(prev => ({
      ...prev,
      [orient]: prev[orient].map((slot, i) => i === index ? { ...slot, faixa: novaFaixa } : slot),
    }));
    syncCurva(orient, index, novaFaixa, curvas[orient][index].pct);
  }

  function resetarCurvas() {
    setCurvas(CURVAS_PADRAO);
    // Reseta também o estado global: POSTa todos os defaults (uma linha por orientação+index)
    for (const orient of Object.keys(CURVAS_PADRAO)) {
      CURVAS_PADRAO[orient].forEach((slot, i) => syncCurva(orient, i, slot.faixa, slot.pct));
    }
  }

  useEffect(() => {
    try { localStorage.setItem(CURVAS_KEY, JSON.stringify(curvas)); } catch {}
  }, [curvas]);

  function exportarOperacionalPDF() {
    if (operacionalFiltrado.length === 0) return;
    const meta = {};
    paineisList.forEach(p => { meta[p.id] = { cidade: p.cidade, sistema: p.sistema }; });
    const esc = s => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const filtros = [
      opPainel !== "Todos" && `Painel: ${opPainel}`,
      opOrient !== "Todas" && `Orientação: ${opOrient}`,
      opFaixa !== "Todas" && `Faixa: ${opFaixa}`,
    ].filter(Boolean).join(" · ") || "Sem filtros (todos os painéis)";
    const linhas = operacionalFiltrado.map(r => `
      <tr>
        <td>${esc(r.id)}</td>
        <td>${esc(r.nome)}</td>
        <td>${esc(meta[r.id]?.cidade)}</td>
        <td>${esc(r.orient)}</td>
        <td>${r.placeholder ? "—" : esc(r.faixa)}</td>
        <td class="pct">${r.pct == null ? '<span class="aviso">sem curva</span>' : esc(r.pct) + "%"}</td>
        <td>${esc(r.label)}</td>
      </tr>`).join("");
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Plano Operacional — Trend</title>
      <style>
        * { box-sizing: border-box; }
        body { font-family: -apple-system, Arial, sans-serif; color: #1e293b; margin: 32px; }
        .head { border-bottom: 3px solid #f97316; padding-bottom: 12px; margin-bottom: 16px; }
        .tag { color: #f97316; font-size: 11px; letter-spacing: 2px; text-transform: uppercase; font-weight: 700; }
        h1 { margin: 4px 0 2px; font-size: 20px; }
        .sub { color: #64748b; font-size: 12px; }
        .meta { font-size: 12px; color: #475569; margin: 10px 0 16px; }
        table { width: 100%; border-collapse: collapse; font-size: 11px; }
        th { background: #f1f5f9; text-align: left; padding: 7px 8px; text-transform: uppercase; font-size: 9px; letter-spacing: .5px; color: #475569; border-bottom: 1px solid #cbd5e1; }
        td { padding: 6px 8px; border-bottom: 1px solid #e2e8f0; }
        tr:nth-child(even) td { background: #f8fafc; }
        .pct { font-weight: 700; }
        .aviso { color: #ef4444; font-weight: 600; }
        @media print { body { margin: 12mm; } @page { size: A4 landscape; } }
      </style></head><body>
      <div class="head">
        <div class="tag">Frota Trend · 2026</div>
        <h1>Plano Operacional — Brilho Painéis LED</h1>
        <div class="sub">Recife · Olinda · Camarigibe · Campina Grande</div>
      </div>
      <div class="meta"><strong>${operacionalFiltrado.length}</strong> linhas · ${esc(filtros)}</div>
      <table>
        <thead><tr><th>ID</th><th>Painel</th><th>Cidade</th><th>Orientação</th><th>Faixa horária</th><th>% Brilho</th><th>Período</th></tr></thead>
        <tbody>${linhas}</tbody>
      </table>
      <script>window.onload = function(){ window.print(); }<\/script>
      </body></html>`;
    const w = window.open("", "_blank");
    if (!w) { alert("Permita pop-ups para exportar o PDF."); return; }
    w.document.write(html);
    w.document.close();
  }

  const sectionCard = { background: theme.panel, border: `1px solid ${theme.border}`, borderRadius: 10, padding: 16 };
  const headerLabelStyle = { fontSize: 10, color: theme.headerSubtle, textTransform: "uppercase", letterSpacing: 1 };

  return (
    <div style={{ background: theme.bg, minHeight: "100vh", fontFamily: "'DM Mono', 'Courier New', monospace", color: theme.text, padding: "0 0 40px", transition: "background 0.2s, color 0.2s" }}>
      {/* Header */}
      <div style={{ background: theme.headerBg, borderBottom: `1px solid ${theme.border}`, padding: "20px 28px 0" }}>
        <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
              <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#f97316", boxShadow: "0 0 8px #f97316" }} />
              <span style={{ fontSize: 11, letterSpacing: 3, color: "#f97316", textTransform: "uppercase" }}>Frota Trend · 2026</span>
            </div>
            <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: theme.headerText, letterSpacing: -0.5 }}>
              Controle de Brilho — Painéis LED
            </h1>
            <p style={{ margin: "4px 0 0", fontSize: 12, color: theme.headerSubtle }}>41 painéis · Recife · Olinda · Camarigibe · Campina Grande</p>
          </div>
          <div style={{ display: "flex", gap: 16, flexWrap: "wrap", paddingBottom: 16, alignItems: "center" }}>
            {[
              { label: "Total", valor: total, cor: "#38bdf8" },
              { label: "Configurados", valor: `${configurados}/${total}`, cor: "#a78bfa" },
              { label: "Concluídos", valor: concluidos, cor: "#22c55e" },
              { label: "Não definidos", valor: naoDefinidos, cor: "#ef4444" },
            ].map(k => (
              <div key={k.label} style={{ background: light ? "rgba(255,255,255,0.1)" : "#0f172a", border: `1px solid ${light ? "rgba(255,255,255,0.15)" : theme.border}`, borderRadius: 8, padding: "8px 16px", textAlign: "center" }}>
                <div style={{ fontSize: 20, fontWeight: 700, color: k.cor }}>{k.valor}</div>
                <div style={headerLabelStyle}>{k.label}</div>
              </div>
            ))}
            <button
              onClick={() => setLight(l => !l)}
              title={light ? "Mudar para modo escuro" : "Mudar para modo claro"}
              style={{
                background: light ? "rgba(255,255,255,0.15)" : "#0f172a",
                border: `1px solid ${light ? "rgba(255,255,255,0.25)" : theme.border}`,
                borderRadius: 8,
                padding: "10px 14px",
                fontSize: 16,
                cursor: "pointer",
                color: theme.headerText,
                fontFamily: "inherit",
              }}
            >
              {light ? "🌙" : "☀️"}
            </button>
          </div>
        </div>
        {/* Abas */}
        <div style={{ display: "flex", gap: 0, marginTop: 8, flexWrap: "wrap" }}>
          {[["paineis", "Painéis"], ["curvas", "Curvas de Brilho"], ["operacional", "Operacional"]].map(([key, label]) => (
            <button key={key} onClick={() => setAba(key)} style={{
              background: "none", border: "none", cursor: "pointer",
              padding: "10px 20px", fontSize: 13, fontFamily: "inherit",
              color: aba === key ? "#f97316" : theme.headerSubtle,
              borderBottom: aba === key ? "2px solid #f97316" : "2px solid transparent",
              fontWeight: aba === key ? 700 : 400,
              transition: "all 0.2s"
            }}>{label}</button>
          ))}
        </div>
      </div>

      <div style={{ padding: "24px 28px" }}>

        {/* ABA PAINÉIS */}
        {aba === "paineis" && (
          <div>
            {/* Progresso */}
            <div style={{ ...sectionCard, marginBottom: 20 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8, fontSize: 12 }}>
                <span style={{ color: theme.textMuted }}>Progresso de configuração de orientação</span>
                <span style={{ color: "#f97316", fontWeight: 700 }}>{Math.round(configurados / total * 100)}%</span>
              </div>
              <div style={{ background: theme.barBg, borderRadius: 99, height: 8, overflow: "hidden" }}>
                <div style={{ width: `${configurados / total * 100}%`, height: "100%", background: "linear-gradient(90deg,#f97316,#fbbf24)", borderRadius: 99, transition: "width 0.5s" }} />
              </div>
              <div style={{ display: "flex", gap: 16, marginTop: 10, fontSize: 11 }}>
                <span style={{ color: "#22c55e" }}>● Concluído: {concluidos}</span>
                <span style={{ color: "#f59e0b" }}>● Em andamento: {paineisList.filter(p => p.status === "Em andamento").length}</span>
                <span style={{ color: "#ef4444" }}>● Pendente: {paineisList.filter(p => p.status === "Pendente").length}</span>
              </div>
            </div>

            {/* Filtros */}
            <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 16 }}>
              <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar painel..." style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 6, padding: "7px 12px", color: theme.text, fontSize: 12, fontFamily: "inherit", flex: 1, minWidth: 160 }} />
              {[["filtroOrient", filtroOrient, setFiltroOrient, ["Todas", ...ORIENTACOES]], ["filtroCidade", filtroCidade, setFiltroCidade, CIDADES], ["filtroStatus", filtroStatus, setFiltroStatus, ["Todos", "Pendente", "Em andamento", "Concluído"]]].map(([key, val, setter, opts]) => (
                <select key={key} value={val} onChange={e => setter(e.target.value)} style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 6, padding: "7px 12px", color: theme.text, fontSize: 12, fontFamily: "inherit" }}>
                  {opts.map(o => <option key={o}>{o}</option>)}
                </select>
              ))}
            </div>

            {/* Tabela */}
            <div style={{ ...sectionCard, padding: 0, overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead>
                  <tr style={{ borderBottom: `1px solid ${theme.border}` }}>
                    {["ID", "Painel", "Cidade", "Sistema", "Orientação", "Status"].map(h => (
                      <th key={h} style={{ padding: "10px 12px", textAlign: "left", color: theme.textMuted, fontWeight: 600, letterSpacing: 1, fontSize: 11, textTransform: "uppercase" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {paineisPaginados.map(p => {
                    const editing = !!editingOrient[p.id] || p.orientacao === "A definir";
                    return (
                      <tr key={p.id} style={{ borderBottom: `1px solid ${theme.borderRow}` }}>
                        <td style={{ padding: "9px 12px", color: "#f97316", fontWeight: 700 }}>{p.id}</td>
                        <td style={{ padding: "9px 12px", color: theme.textBright }}>{p.nome}</td>
                        <td style={{ padding: "9px 12px", color: theme.text }}>{p.cidade}</td>
                        <td style={{ padding: "9px 12px", color: theme.textMuted }}>{p.sistema}</td>
                        <td style={{ padding: "9px 12px" }}>
                          {editing ? (
                            <div style={{ display: "flex", gap: 4, alignItems: "center" }}>
                              <select value={novaOrient[p.id] ?? ""} onChange={e => setNovaOrient(prev => ({ ...prev, [p.id]: e.target.value }))}
                                style={{ background: theme.selectBg, border: `1px solid ${theme.selectBorder}`, borderRadius: 4, padding: "3px 6px", color: theme.text, fontSize: 11, fontFamily: "inherit" }}>
                                <option value="">-- definir --</option>
                                {["Norte", "Sul", "Leste", "Oeste"].map(o => <option key={o}>{o}</option>)}
                              </select>
                              {novaOrient[p.id] && (
                                <button onClick={() => salvarOrientacao(p.id)} title="Salvar"
                                  style={{ background: "#f97316", border: "none", borderRadius: 4, padding: "3px 8px", color: "#fff", cursor: "pointer", fontSize: 11, fontFamily: "inherit" }}>✓</button>
                              )}
                              {p.orientacao !== "A definir" && (
                                <button onClick={() => cancelarEdicao(p.id)} title="Cancelar"
                                  style={{ background: "transparent", border: `1px solid ${theme.selectBorder}`, borderRadius: 4, padding: "3px 8px", color: theme.textMuted, cursor: "pointer", fontSize: 11, fontFamily: "inherit" }}>×</button>
                              )}
                            </div>
                          ) : (
                            <button onClick={() => iniciarEdicao(p.id, p.orientacao)} title="Editar orientação"
                              style={{ background: theme.pillBg, color: theme.pillText, border: "none", padding: "3px 10px", borderRadius: 99, fontSize: 11, cursor: "pointer", fontFamily: "inherit", display: "inline-flex", alignItems: "center", gap: 6 }}>
                              {p.orientacao} <span style={{ opacity: 0.7, fontSize: 10 }}>✎</span>
                            </button>
                          )}
                        </td>
                        <td style={{ padding: "9px 12px" }}>
                          <button onClick={() => toggleStatus(p.id)}
                            style={{ background: theme.statusBg[p.status], color: theme.statusFg[p.status], border: `1px solid ${theme.statusFg[p.status]}55`, borderRadius: 99, padding: "2px 10px", fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>
                            {p.status}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {paineisFiltrados.length === 0 && <div style={{ textAlign: "center", color: theme.textMuted, padding: 32 }}>Nenhum painel encontrado.</div>}
              {paineisFiltrados.length > 0 && (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderTop: `1px solid ${theme.border}`, flexWrap: "wrap", gap: 8 }}>
                  <div style={{ fontSize: 11, color: theme.textMuted }}>
                    Mostrando {(paginaPaineisAtual - 1) * POR_PAGINA + 1}–{Math.min(paginaPaineisAtual * POR_PAGINA, paineisFiltrados.length)} de {paineisFiltrados.length}
                  </div>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    <button onClick={() => setPagPaineis(1)} disabled={paginaPaineisAtual === 1}
                      style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 4, padding: "4px 8px", color: paginaPaineisAtual === 1 ? theme.textSubtle : theme.text, fontSize: 11, cursor: paginaPaineisAtual === 1 ? "default" : "pointer", fontFamily: "inherit" }}>«</button>
                    <button onClick={() => setPagPaineis(p => Math.max(1, p - 1))} disabled={paginaPaineisAtual === 1}
                      style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 4, padding: "4px 10px", color: paginaPaineisAtual === 1 ? theme.textSubtle : theme.text, fontSize: 11, cursor: paginaPaineisAtual === 1 ? "default" : "pointer", fontFamily: "inherit" }}>‹ Anterior</button>
                    <span style={{ fontSize: 11, color: theme.text, padding: "0 8px" }}>
                      Página <strong style={{ color: "#f97316" }}>{paginaPaineisAtual}</strong> de {totalPaginasPaineis}
                    </span>
                    <button onClick={() => setPagPaineis(p => Math.min(totalPaginasPaineis, p + 1))} disabled={paginaPaineisAtual === totalPaginasPaineis}
                      style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 4, padding: "4px 10px", color: paginaPaineisAtual === totalPaginasPaineis ? theme.textSubtle : theme.text, fontSize: 11, cursor: paginaPaineisAtual === totalPaginasPaineis ? "default" : "pointer", fontFamily: "inherit" }}>Próxima ›</button>
                    <button onClick={() => setPagPaineis(totalPaginasPaineis)} disabled={paginaPaineisAtual === totalPaginasPaineis}
                      style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 4, padding: "4px 8px", color: paginaPaineisAtual === totalPaginasPaineis ? theme.textSubtle : theme.text, fontSize: 11, cursor: paginaPaineisAtual === totalPaginasPaineis ? "default" : "pointer", fontFamily: "inherit" }}>»</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

        {/* ABA CURVAS */}
        {aba === "curvas" && (
          <div>
            <div style={{ display: "flex", gap: 8, marginBottom: 20, flexWrap: "wrap" }}>
              {Object.keys(curvas).map(o => (
                <button key={o} onClick={() => setCurvaOrient(o)} style={{
                  background: curvaOrient === o ? "#f97316" : theme.panel,
                  border: `1px solid ${curvaOrient === o ? "#f97316" : theme.border}`,
                  borderRadius: 6, padding: "7px 18px", color: curvaOrient === o ? "#fff" : theme.text,
                  cursor: "pointer", fontFamily: "inherit", fontSize: 13, fontWeight: curvaOrient === o ? 700 : 400
                }}>{o}</button>
              ))}
            </div>

            <div style={{ ...sectionCard, padding: 20, marginBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap", marginBottom: 4 }}>
                <div style={{ fontSize: 13, color: light ? "#1e40af" : "#7dd3fc", fontWeight: 700 }}>Curva — Orientação {curvaOrient}</div>
                <button
                  onClick={resetarCurvas}
                  title="Restaurar todas as curvas para os valores padrão"
                  style={{ background: "transparent", border: `1px solid ${theme.inputBorder}`, borderRadius: 6, padding: "5px 12px", color: theme.textMuted, fontSize: 11, fontWeight: 600, fontFamily: "inherit", cursor: "pointer" }}
                >
                  ↺ Restaurar padrão
                </button>
              </div>
              <div style={{ fontSize: 11, color: theme.textMuted, marginBottom: 16 }}>Dia ensolarado · Fator nublado ×0,6 · Chuvoso ×0,4 · <span style={{ color: "#f97316" }}>edite a faixa de horário e o % em cada slot abaixo</span></div>

              <div style={{ display: "flex", gap: 6, alignItems: "flex-end", height: 120, marginBottom: 12 }}>
                {curvas[curvaOrient].map((slot, i) => (
                  <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: 3 }}>
                    <span style={{ fontSize: 9, color: pctColor(slot.pct), fontWeight: 700 }}>{slot.pct}%</span>
                    <div style={{ width: "100%", height: `${slot.pct}%`, background: pctColor(slot.pct), borderRadius: "3px 3px 0 0", opacity: 0.85, minHeight: 2, transition: "height 0.5s" }} />
                  </div>
                ))}
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(130px, 1fr))", gap: 8 }}>
                {curvas[curvaOrient].map((slot, i) => (
                  <div key={i} style={{ background: theme.cardInner, border: `1px solid ${theme.border}`, borderRadius: 8, padding: "10px 12px" }}>
                    <input
                      type="text"
                      value={slot.faixa}
                      onChange={e => ajustarFaixa(curvaOrient, i, e.target.value)}
                      title="Editar faixa de horário"
                      style={{ width: 90, maxWidth: "100%", background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 5, padding: "3px 6px", color: theme.textMuted, fontSize: 10, fontFamily: "inherit", marginBottom: 6 }}
                    />
                    <div style={{ display: "flex", alignItems: "center", gap: 4, marginBottom: 6 }}>
                      <input
                        type="number"
                        min={0}
                        max={100}
                        value={slot.pct}
                        onChange={e => ajustarPct(curvaOrient, i, e.target.value)}
                        style={{ width: 52, background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 5, padding: "4px 6px", color: pctColor(slot.pct), fontSize: 13, fontWeight: 700, fontFamily: "inherit", textAlign: "right" }}
                      />
                      <span style={{ fontSize: 12, color: theme.textMuted, fontWeight: 700 }}>%</span>
                    </div>
                    <BrilhoBar pct={slot.pct} theme={theme} />
                    <div style={{ fontSize: 10, color: theme.textSubtle, marginTop: 4 }}>{slot.label}</div>
                  </div>
                ))}
              </div>
            </div>

            <div style={sectionCard}>
              <div style={{ fontSize: 12, color: theme.text, fontWeight: 700, marginBottom: 10 }}>Fatores de Ajuste Climático</div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                {[["☀️ Ensolarado", "×1,0", "#f97316"], ["🌤 Parcial", "×0,8", "#facc15"], ["☁️ Nublado", "×0,6", "#38bdf8"], ["🌧 Chuvoso", "×0,4", "#6366f1"]].map(([c, f, cor]) => (
                  <div key={c} style={{ background: theme.cardInner, border: `1px solid ${cor}55`, borderRadius: 8, padding: "8px 14px", display: "flex", gap: 8, alignItems: "center" }}>
                    <span style={{ fontSize: 13, color: theme.text }}>{c}</span>
                    <span style={{ color: cor, fontWeight: 700, fontSize: 14 }}>{f}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ABA OPERACIONAL */}
        {aba === "operacional" && (
          <div>
            <div style={{ ...sectionCard, marginBottom: 16 }}>
              <div style={{ fontSize: 13, color: theme.textBright, fontWeight: 700, marginBottom: 4 }}>Configuração Operacional</div>
              <div style={{ fontSize: 11, color: theme.textMuted, marginBottom: 14 }}>
                Lista plana de cada painel × faixa horária com o % de brilho a aplicar. Painéis sem orientação aparecem com um aviso — defina a orientação na aba Painéis.
              </div>
              <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
                <select value={opPainel} onChange={e => setOpPainel(e.target.value)} style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 6, padding: "7px 12px", color: theme.text, fontSize: 12, fontFamily: "inherit" }}>
                  <option>Todos</option>
                  {paineisList.map(p => <option key={p.id}>{p.id}</option>)}
                </select>
                <select value={opOrient} onChange={e => setOpOrient(e.target.value)} style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 6, padding: "7px 12px", color: theme.text, fontSize: 12, fontFamily: "inherit" }}>
                  <option>Todas</option>
                  {["Norte", "Sul", "Leste", "Oeste"].map(o => <option key={o}>{o}</option>)}
                </select>
                <select value={opFaixa} onChange={e => setOpFaixa(e.target.value)} style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 6, padding: "7px 12px", color: theme.text, fontSize: 12, fontFamily: "inherit" }}>
                  <option>Todas</option>
                  {FAIXAS.map(f => <option key={f}>{f}</option>)}
                </select>
                <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 12 }}>
                  <span style={{ fontSize: 11, color: theme.textMuted }}>
                    {operacionalFiltrado.length} linhas
                  </span>
                  <button
                    onClick={exportarOperacionalCSV}
                    disabled={operacionalFiltrado.length === 0}
                    title="Exportar o plano operacional (com os filtros atuais) em CSV"
                    style={{
                      background: "#f97316",
                      border: "none",
                      borderRadius: 6,
                      padding: "7px 14px",
                      color: "#fff",
                      fontSize: 12,
                      fontWeight: 700,
                      fontFamily: "inherit",
                      cursor: operacionalFiltrado.length === 0 ? "not-allowed" : "pointer",
                      opacity: operacionalFiltrado.length === 0 ? 0.5 : 1,
                    }}
                  >
                    ↓ Exportar CSV
                  </button>
                  <button
                    onClick={exportarOperacionalPDF}
                    disabled={operacionalFiltrado.length === 0}
                    title="Exportar o plano operacional (com os filtros atuais) em PDF"
                    style={{
                      background: "transparent",
                      border: "1px solid #f97316",
                      borderRadius: 6,
                      padding: "6px 14px",
                      color: "#f97316",
                      fontSize: 12,
                      fontWeight: 700,
                      fontFamily: "inherit",
                      cursor: operacionalFiltrado.length === 0 ? "not-allowed" : "pointer",
                      opacity: operacionalFiltrado.length === 0 ? 0.5 : 1,
                    }}
                  >
                    ↓ Exportar PDF
                  </button>
                </div>
              </div>
            </div>

            <div style={{ ...sectionCard, padding: 0, overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12 }}>
                <thead>
                  <tr style={{ borderBottom: `1px solid ${theme.border}` }}>
                    {["ID", "Painel", "Orientação", "Hora", "% Brilho"].map(h => (
                      <th key={h} style={{ padding: "10px 12px", textAlign: "left", color: theme.textMuted, fontWeight: 600, letterSpacing: 1, fontSize: 11, textTransform: "uppercase" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {opPaginado.map((r, i) => (
                    <tr key={i} style={{ borderBottom: `1px solid ${theme.borderRow}` }}>
                      <td style={{ padding: "8px 12px", color: "#f97316", fontWeight: 700 }}>{r.id}</td>
                      <td style={{ padding: "8px 12px", color: theme.textBright }}>{r.nome}</td>
                      <td style={{ padding: "8px 12px" }}>
                        {r.placeholder ? (
                          <span style={{ background: theme.statusBg["Pendente"], color: theme.statusFg["Pendente"], padding: "2px 8px", borderRadius: 99, fontSize: 11 }}>A definir</span>
                        ) : (
                          <span style={{ background: theme.pillBg, color: theme.pillText, padding: "2px 8px", borderRadius: 99, fontSize: 11 }}>{r.orient}</span>
                        )}
                      </td>
                      <td style={{ padding: "8px 12px", color: theme.text }}>{r.faixa}</td>
                      <td style={{ padding: "8px 12px", minWidth: 180 }}>
                        {r.placeholder ? (
                          <button onClick={() => { setAba("paineis"); iniciarEdicao(r.id, "A definir"); }}
                            style={{ background: "transparent", border: `1px dashed ${theme.statusFg["Pendente"]}`, color: theme.statusFg["Pendente"], padding: "3px 10px", borderRadius: 6, fontSize: 11, cursor: "pointer", fontFamily: "inherit" }}>
                            Definir orientação →
                          </button>
                        ) : (
                          <BrilhoBar pct={r.pct} theme={theme} />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {operacionalFiltrado.length === 0 && (
                <div style={{ textAlign: "center", color: theme.textMuted, padding: 32 }}>Nenhum registro com os filtros aplicados.</div>
              )}
              {operacionalFiltrado.length > 0 && (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderTop: `1px solid ${theme.border}`, flexWrap: "wrap", gap: 8 }}>
                  <div style={{ fontSize: 11, color: theme.textMuted }}>
                    Mostrando {(opPaginaAtual - 1) * OP_POR_PAGINA + 1}–{Math.min(opPaginaAtual * OP_POR_PAGINA, operacionalFiltrado.length)} de {operacionalFiltrado.length}
                  </div>
                  <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                    <button onClick={() => setOpPagina(1)} disabled={opPaginaAtual === 1}
                      style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 4, padding: "4px 8px", color: opPaginaAtual === 1 ? theme.textSubtle : theme.text, fontSize: 11, cursor: opPaginaAtual === 1 ? "default" : "pointer", fontFamily: "inherit" }}>«</button>
                    <button onClick={() => setOpPagina(p => Math.max(1, p - 1))} disabled={opPaginaAtual === 1}
                      style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 4, padding: "4px 10px", color: opPaginaAtual === 1 ? theme.textSubtle : theme.text, fontSize: 11, cursor: opPaginaAtual === 1 ? "default" : "pointer", fontFamily: "inherit" }}>‹ Anterior</button>
                    <span style={{ fontSize: 11, color: theme.text, padding: "0 8px" }}>
                      Página <strong style={{ color: "#f97316" }}>{opPaginaAtual}</strong> de {opTotalPaginas}
                    </span>
                    <button onClick={() => setOpPagina(p => Math.min(opTotalPaginas, p + 1))} disabled={opPaginaAtual === opTotalPaginas}
                      style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 4, padding: "4px 10px", color: opPaginaAtual === opTotalPaginas ? theme.textSubtle : theme.text, fontSize: 11, cursor: opPaginaAtual === opTotalPaginas ? "default" : "pointer", fontFamily: "inherit" }}>Próxima ›</button>
                    <button onClick={() => setOpPagina(opTotalPaginas)} disabled={opPaginaAtual === opTotalPaginas}
                      style={{ background: theme.inputBg, border: `1px solid ${theme.inputBorder}`, borderRadius: 4, padding: "4px 8px", color: opPaginaAtual === opTotalPaginas ? theme.textSubtle : theme.text, fontSize: 11, cursor: opPaginaAtual === opTotalPaginas ? "default" : "pointer", fontFamily: "inherit" }}>»</button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
